<template>
  <div>
    <base-card class="search-banner-block">
    <span>{{$t('search-banner')}}</span> <a href="/terminos-condiciones-paciente" target="_blank">{{$t('our-policy')}}</a>
    </base-card>
  </div>
</template>

<script>
import BaseCard from '@/components/base/ui/BaseCard'

export default {
    components: {
      BaseCard
    }
}
</script>

<style lang="scss" scoped>
.search-banner-block{
    background-color: #DADCDE;
    border-color: #DADCDE;
    margin-bottom: 1.5rem;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/search/SearchBannerBlock.vue